import { cn } from '@/lib/utils'
import { type CarbonIconType as LucideIcon } from '@carbon/icons-react'

interface TimelineItem {
  year: string
  title: string
  description: string
  icon?: LucideIcon
  color?: string
}

interface TimelineProps {
  items: TimelineItem[]
}

export function Timeline({ items }: TimelineProps) {
  return (
    <div className="relative my-12">
      {/* Timeline line */}
      <div className="absolute left-8 top-0 bottom-0 w-px bg-border" />

      <div className="space-y-8">
        {items.map((item, index) => {
          const Icon = item.icon
          return (
            <div key={index} className="relative flex gap-6">
              {/* Icon/Year Circle */}
              <div className="relative flex-shrink-0">
                <div
                  className={cn(
                    'w-16 h-16 rounded-full flex items-center justify-center font-bold text-sm border-2',
                    'bg-background border-emerald-600 dark:border-primary-active text-emerald-600 dark:text-primary-active'
                  )}
                >
                  {Icon ? <Icon className="w-6 h-6" /> : item.year}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 pb-8">
                <div className="border border-border rounded-lg p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xl font-bold text-emerald-600 dark:text-primary-active">
                      {item.year}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-foreground">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed text-sm">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
